module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tutorials-doing-with-scxml.json
// module id = 811
// module chunks = 77849267939990